import { IconBase, IconComponent } from './BaseIcon';

export const Delete: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="m10.992 23.623.022-11.38 2 .003-.022 11.38zm3.928 0 .021-11.38 2 .003-.021 11.38zm4.077 0 .022-11.38 2 .003-.022 11.38zM27.94 5.75h-7.66a4.4 4.4 0 0 0-8.68 0H3.94v2H5v.29L6.71 26.6a3.73 3.73 0 0 0 3.76 3.4h10.94a3.73 3.73 0 0 0 3.76-3.4L26.81 8v-.29h1.11zm-4.76 20.68A1.75 1.75 0 0 1 21.41 28H10.47a1.75 1.75 0 0 1-1.77-1.57L7.07 7.87h17.75zM15.94 4.09a2.41 2.41 0 0 1 2.28 1.66h-4.56a2.41 2.41 0 0 1 2.28-1.66z" />
  </IconBase>
);
